var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoreHoriz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "more_horiz"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_608_9672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.244141,
    y: 0.0463867,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_608_9672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "more_horiz_2",
    d: "M6.24414 12.8836C5.69414 12.8836 5.22331 12.6826 4.83164 12.2808C4.43997 11.8789 4.24414 11.3958 4.24414 10.8314C4.24414 10.2671 4.43997 9.78399 4.83164 9.38211C5.22331 8.98024 5.69414 8.7793 6.24414 8.7793C6.79414 8.7793 7.26497 8.98024 7.65664 9.38211C8.04831 9.78399 8.24414 10.2671 8.24414 10.8314C8.24414 11.3958 8.04831 11.8789 7.65664 12.2808C7.26497 12.6826 6.79414 12.8836 6.24414 12.8836ZM12.2441 12.8836C11.6941 12.8836 11.2233 12.6826 10.8316 12.2808C10.44 11.8789 10.2441 11.3958 10.2441 10.8314C10.2441 10.2671 10.44 9.78399 10.8316 9.38211C11.2233 8.98024 11.6941 8.7793 12.2441 8.7793C12.7941 8.7793 13.265 8.98024 13.6566 9.38211C14.0483 9.78399 14.2441 10.2671 14.2441 10.8314C14.2441 11.3958 14.0483 11.8789 13.6566 12.2808C13.265 12.6826 12.7941 12.8836 12.2441 12.8836ZM18.2441 12.8836C17.6941 12.8836 17.2233 12.6826 16.8316 12.2808C16.44 11.8789 16.2441 11.3958 16.2441 10.8314C16.2441 10.2671 16.44 9.78399 16.8316 9.38211C17.2233 8.98024 17.6941 8.7793 18.2441 8.7793C18.7941 8.7793 19.265 8.98024 19.6566 9.38211C20.0483 9.78399 20.2441 10.2671 20.2441 10.8314C20.2441 11.3958 20.0483 11.8789 19.6566 12.2808C19.265 12.6826 18.7941 12.8836 18.2441 12.8836Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreHoriz);
export default __webpack_public_path__ + "static/media/icon_more_horiz.01e68f4e66a204d344d879df282ddb8a.svg";
export { ForwardRef as ReactComponent };